import React, { type FC } from 'react';

import { ContentByLabelMacroHandler } from '@confluence/content-by-label-macro/entry-points/ContentByLabelMacroRenderer.ts';
import type { ContentByLabelMacroParams } from '@confluence/content-by-label-macro/entry-points/ContentByLabelMacroTypes.ts';
import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import type { RendererExtensionHandlers } from '@confluence/fabric-extension-lib/entry-points/extensionTypes.ts';

import { NestedAdfSSRRendererWrapperProvider } from './NestedAdfSSRRendererWrapperProvider.tsx';

type ContentByLabelSSRExtensionHandlerProps = ExtensionHandlerProps & {
	appearance?: string;
	Renderer: FC<any>;
	getExtensionHandlers: (options: any) => RendererExtensionHandlers;
	macroParams?: ContentByLabelMacroParams;
};

export const ContentByLabelSSRExtensionHandler: FC<ContentByLabelSSRExtensionHandlerProps> = ({
	contentId,
	extensionKey,
	mode,
	node,
	spaceKey,
	appearance,
	showTemplateVariablesInPreview,
	showTemplateInputInPreview,
	Renderer,
	getExtensionHandlers,
	macroParams,
}) => (
	<NestedAdfSSRRendererWrapperProvider
		appearance={appearance}
		Renderer={Renderer}
		getExtensionHandlers={getExtensionHandlers}
		showTemplateInputInPreview={showTemplateInputInPreview}
		showTemplateVariablesInPreview={showTemplateVariablesInPreview}
	>
		{(RendererWrapper) => (
			<ContentByLabelMacroHandler
				macroDefaultProps={{
					contentId,
					extensionKey,
					mode,
					node,
					spaceKey,
				}}
				macroParams={macroParams ?? node?.parameters?.macroParams}
				RendererWrapper={RendererWrapper}
			/>
		)}
	</NestedAdfSSRRendererWrapperProvider>
);
